import React from 'react';

import { IIconArrowLeft } from './types';

/* A note when using this component - you will need to pass a fill color if you want anything other than black. */

const IconArrowLeft: React.FC<IIconArrowLeft> = props => (
  <svg viewBox="0.5 0.5 8.5 12.5" aria-hidden {...props}>
    <title>Arrow Left Icon</title>
    <path d="M3.768 6.95l4.066-4.066a1.25 1.25 0 0 0-1.768-1.768l-4.95 4.95a1.25 1.25 0 0 0 0 1.768l4.596 4.596a1.25 1.25 0 1 0 1.768-1.768L3.768 6.95z" />
  </svg>
);

export default IconArrowLeft;
